
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.732 9.973a.873.873 0 00.852.85h12.9l-3.75 4.191a.822.822 0 00.056 1.19.73.73 0 00.568.227.914.914 0 00.625-.284l5.058-5.608a.885.885 0 00.17-.906l-.34-.34-4.888-5.439a.844.844 0 00-1.25 1.133l3.75 4.192H2.642a.877.877 0 00-.91.794z"}})])
          )
        }
      }
    